<div class="server-unreachable-overlay" role="alertdialog" aria-modal="true" *transloco="let t">
  <div class="server-unreachable-overlay__content">
    <mat-icon class="server-unreachable-overlay__icon" aria-hidden="true">cloud_off</mat-icon>
    <h1 class="server-unreachable-overlay__title">{{ t('app.server_unreachable.title') }}</h1>
    <p class="server-unreachable-overlay__message">{{ t('app.server_unreachable.message') }}</p>
    <button mat-stroked-button type="button" class="server-unreachable-overlay__retry" (click)="retry()">
      <mat-icon>refresh</mat-icon>
      {{ t('app.server_unreachable.retry') }}
    </button>
  </div>
</div>
